interface DidTeamWinParams {
  teamScore: number;
  opponentScore: number;
  teamPenaltyScore: number;
  opponentPenaltyScore: number;
}

const didTeamWin = ({
  teamScore,
  opponentScore,
  teamPenaltyScore,
  opponentPenaltyScore,
}: DidTeamWinParams) =>
  teamScore > opponentScore ||
  (teamScore === opponentScore && teamPenaltyScore > opponentPenaltyScore);

export default didTeamWin;
